import * as React from 'react';
import { DesktopSignOutForm } from '../../components/forms/desktop-sign-out-form/desktop-sign-out-form.component';
import { PageMeta } from '../../components/page-meta';
import { AuthPageLayout } from '../../ui/layout/auth-page-layout/auth-page-layout.component';

export const DesktopSignOut: React.FC = () => {
  return (
    <AuthPageLayout>
      <PageMeta title="ui-desktop-signed-out" description="ui-desktop-signed-out-description" />
      <DesktopSignOutForm />
    </AuthPageLayout>
  );
};
